export function escapeHtml(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Prefixe un champ pseudo avec "@" au fil de la frappe, un seul : si
// l'utilisateur tape lui-meme "@" (avant ou apres celui ajoute), les "@" en
// tete sont ramenes a un.
// Partage entre proposer, posters, dashboard et ajout photo carte.
export function applyAtPrefix(inputEl) {
  const value = inputEl.value;
  if (!value) return;
  const leading = value.match(/^@*/)[0].length;
  if (leading === 1) return;
  const pos = Math.max(1, inputEl.selectionStart + 1 - leading);
  inputEl.value = '@' + value.slice(leading);
  inputEl.setSelectionRange(pos, pos);
}
